import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {HttpClient, HttpClientModule} from "@angular/common/http";

import {TranslateLoader, TranslateModule} from "@ngx-translate/core";

import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {HomeModule} from "./components/home/home.component";
import {InformationModule} from "./components/information/information.component";
import {UnsubscribeModule} from "./components/unsubscribe/unsubscribe.component";
import {httpLoaderFactory} from "./shared/factory/http-loader-factory";
import {RouteAccessGuard} from "./shared/guard/route-access.guard";
import {MotoAiRegistrationService} from "./shared/service/moto-ai-registration.service";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    HomeModule,
    InformationModule,
    UnsubscribeModule
  ],
  providers: [
    RouteAccessGuard,
    MotoAiRegistrationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

